// maintain alphabetical order
export const jaBrandSafety = {
  AdomainContainsDescription: '「含む」の場合は、キーワードを追加してください。',
  AdomainExactMatchDescription: 'adomains はまず完全一致かどうかチェックされます。指定された adomain がプレーンテキスト形式の場合、URL のバリエーションと照合されます。',
  AllowedCreatives: '許可されたクリエイティブ',
  AllowList: '許可リスト',
  BlockBidsWithMissingValues: '値が無い入札をブロックする',
  BrandSafetyEventTrackerRuleTypeDescription: 'イベント トラッカーはドメインに対してチェックされます。',
  BrandSafetyMediafileRuleTypeDescription: 'メディアファイルのドメインを入力してください（パスは任意）。メディアファイルのドメインは、まず完全一致でチェックされます。指定されたメディアファイルのドメインがプレーンテキストで記述されている場合は、URLのバリエーションと照合されます（例：getpublica.com は https://getpublica.com/mediafile.mp4、http://getpublica.com/path/to/mediafile.mp4 などと一致します）。',
  BrandSafetySnackbarRuleEachExceptionMustTargetAtLeastOneBidder: '各例外は少なくとも １つのビダーを対象とする必要があります。',
  BrandSafetySnackbarRuleMustTargetAtLeastOne: 'ルールは少なくとも 1 つの IAB、Adomain、Mediafile ドメイン、クリエイティブ ID、イベント トラッカー、または言語をターゲットにする必要があります',
  BrandSafetySnackbarRuleMustTargetAtLeastOneItem: 'ルールは少なくとも 1 つの {{item}} をターゲットにする必要があります',
  BrandSafetyTooltipBlockBidsWithMissingValues: 'このオプションを使用すると、IABカテゴリーまたはAdomainが無い場合に入札レスポンスをブロックできます。IABカテゴリーが無い入札レスポンスをブロックするには、ブロックリストでIABカテゴリーを指定する必要があります。Adomainが無い入札レスポンスをブロックするには、ブロックリストでAdomainを指定する必要があります。',
  BrandSafetyTooltipDayparting: '広告を配信したい曜日と時間帯を設定するには、デイパーティング（時間帯別設定）を使用してください。複数のオプションを追加すると、より細かい設定が可能になります。',
  BrandSafetyTooltipDaypartingExclude: '選択した曜日と時間帯には広告は配信されません。',
  BrandSafetyTooltipDaypartingInclude: '選択した曜日と時間帯に広告が配信されます。',
  BrandSafetyTooltipIncludesBidsWithMissingAdomains: 'これには、adomain（広告ドメイン）が無い入札も含まれます。',
  BrandSafetyTooltipLanguage: '言語ルールは、Eléa AI が有効になっているチャネルにのみ適用されます。',
  BrandSafetyTooltipReviewBlockedCreatives: 'このオプションを使用すると、ブロックされているクリエイティブがブランドセーフティ内の「クリエイティブ レビュー」タブに表示されるようになります。広告、クリエイティブURL、関連するIABカテゴリーとドメインを確認し、ブロックを確定するか、例外を作成して広告の掲載を許可するかを判断できます。',
  CreativeIDCheckedForExactMatch: 'クリエイティブ ID が完全に一致するかどうかがチェックされます。',
  IAB10Appliances: '家電製品',
  IAB10Entertaining: 'エンターテイメント',
  IAB10EnvironmentalSafety: '環境安全',
  IAB10Gardening: '園芸',
  IAB10HomeAndGarden: 'ホーム＆ガーデン',
  IAB10HomeRepair: '住宅修理',
  IAB10HomeTheater: 'ホームシアター',
  IAB10InteriorDecorating: 'インテリアデコレーション',
  IAB10Landscaping: '造園',
  IAB10RemodelingAndConstruction: '改装・建設',
  IAB11Commentary: '解説',
  IAB11Immigration: '移民',
  IAB11LawGovtAndPolitics: '法律、政府、政治',
  IAB11LegalIssues: '法的問題',
  IAB11Politics: '政治',
  IAB11USGovernmentResources: '米国政府のリソース',
  IAB12InternationalNews: '国際ニュース',
  IAB12LocalNews: 'ローカルニュース',
  IAB12NationalNews: '全国ニュース',
  IAB12News: 'ニュース',
  IAB13BeginningInvesting: '投資を始める',
  IAB13CreditDebtAndLoans: 'クレジット/負債とローン',
  IAB13FinancialNews: '金融ニュース',
  IAB13FinancialPlanning: '財務計画',
  IAB13HedgeFund: 'ヘッジファンド',
  IAB13Insurance: '保険',
  IAB13Investing: '投資',
  IAB13MutualFunds: '投資信託',
  IAB13Options: 'オプション',
  IAB13PersonalFinance: '個人金融',
  IAB13RetirementPlanning: '退職計画',
  IAB13Stocks: '株式',
  IAB13TaxPlanning: '税務計画',
  IAB14Dating: 'デート',
  IAB14DivorceSupport: '離婚サポート',
  IAB14EthnicSpecific: '民族特有の',
  IAB14GayLife: 'ゲイライフ',
  IAB14Marriage: '結婚',
  IAB14SeniorLiving: 'シニアリビング',
  IAB14Society: '社会',
  IAB14Teens: '十代の若者たち',
  IAB14Weddings: '結婚式',
  IAB15Astrology: '占星術',
  IAB15Biology: '生物学',
  IAB15Botany: '植物学',
  IAB15Chemistry: '化学',
  IAB15Geography: '地理',
  IAB15Geology: '地質学',
  IAB15ParanormalPhenomena: '超常現象',
  IAB15Physics: '物理',
  IAB15Science: '科学',
  IAB15SpaceAstronomy: '宇宙/天文学',
  IAB15Weather: '天気',
  IAB16Aquariums: '水族館',
  IAB16Birds: '鳥',
  IAB16Cats: '猫',
  IAB16Dogs: '犬',
  IAB16LargeAnimals: '大型動物',
  IAB16Pets: 'ペット',
  IAB16Reptiles: '爬虫類',
  IAB16VeterinaryMedicine: '獣医学',
  IAB17AutoRacing: '自動車レース',
  IAB17Baseball: '野球',
  IAB17Bicycling: '自転車に乗る',
  IAB17Bodybuilding: 'ボディビルディング',
  IAB17Boxing: 'ボクシング',
  IAB17CanoeingKayaking: 'カヌー/カヤック',
  IAB17Cheerleading: 'チアリーディング',
  IAB17Climbing: 'クライミング',
  IAB17Cricket: 'クリケット',
  IAB17FigureSkating: 'フィギュアスケート',
  IAB17FlyFishing: 'フライフィッシング',
  IAB17Football: 'フットボール',
  IAB17FreshwaterFishing: '淡水釣り',
  IAB17GameAndFish: 'ゲーム＆フィッシュ',
  IAB17Golf: 'ゴルフ',
  IAB17HorseRacing: '競馬',
  IAB17Horses: '馬',
  IAB17HuntingShooting: '狩猟/射撃',
  IAB17InlineSkating: 'インラインスケート',
  IAB17MartialArts: '武道',
  IAB17MountainBiking: 'マウンテンバイク',
  IAB17NASCARRacing: 'NASCARレース',
  IAB17Olympics: 'オリンピック',
  IAB17Paintball: 'ペイントボール',
  IAB17PowerAndMotorcycles: 'パワー＆バイク',
  IAB17ProBasketball: 'プロバスケットボール',
  IAB17ProIceHockey: 'プロアイスホッケー',
  IAB17Rodeo: 'ロデオ',
  IAB17Rugby: 'ラグビー',
  IAB17RunningJogging: 'ランニング/ジョギング',
  IAB17Sailing: 'セーリング',
  IAB17SaltwaterFishing: '海釣り',
  IAB17ScubaDiving: 'スキューバダイビング',
  IAB17Skateboarding: 'スケートボード',
  IAB17Skiing: 'スキー',
  IAB17Snowboarding: 'スノーボード',
  IAB17Sports: 'スポーツ',
  IAB17SurfingBodyboarding: 'サーフィン/ボディボード',
  IAB17Swimming: '水泳',
  IAB17TableTennisPingPong: '卓球',
  IAB17Tennis: 'テニス',
  IAB17Volleyball: 'バレーボール',
  IAB17Walking: 'ウォーキング',
  IAB17WaterskiWakeboard: '水上スキー/ウェイクボード',
  IAB17WorldSoccer: 'ワールドサッカー',
  IAB18Accessories: 'アクセサリー',
  IAB18Beauty: '美しさ',
  IAB18BodyArt: 'ボディアート',
  IAB18Clothing: '衣類',
  IAB18Fashion: 'ファッション',
  IAB18Jewelry: 'ジュエリー',
  IAB18StyleAndFashion: 'スタイルとファッション',
  IAB19Animation: 'アニメーション',
  IAB19AntivirusSoftware: 'ウイルス対策ソフトウェア',
  IAB19CamerasAndCamcorders: 'カメラとビデオカメラ',
  IAB19CCPlusPlus: 'C/C++',
  IAB19CellPhones: '携帯電話',
  IAB19ComputerCertification: 'コンピュータ認定',
  IAB19ComputerNetworking: 'コンピュータネットワーク',
  IAB19ComputerPeripherals: 'コンピュータ周辺機器',
  IAB19ComputerReviews: 'コンピューターレビュー',
  IAB19Databases: 'データベース',
  IAB19DataCenters: 'データセンター',
  IAB19DesktopPublishing: 'デスクトップパブリッシング',
  IAB19DesktopVideo: 'デスクトップビデオ',
  IAB19Email: 'メール',
  IAB19Entertainment: 'エンターテインメント',
  IAB19GraphicsSoftware: 'グラフィックソフトウェア',
  IAB19HomeVideoDVD: 'ホームビデオ/DVD',
  IAB19InternetTechnology: 'インターネット技術',
  IAB19Java: 'ジャワ',
  IAB19JavaScript: 'JavaScript',
  IAB19MacSupport: 'Mac サポート',
  IAB19MP3MIDI: 'MP3/MIDI',
  IAB19NetConferencing: 'ネット会議',
  IAB19NetForBeginners: '初心者のためのネット',
  IAB19NetworkSecurity: 'ネットワークセキュリティ',
  IAB19PalmtopsPDAs: 'パームトップ/PDA',
  IAB19PCSupport: 'PCサポート',
  IAB19Portable: 'ポータブル',
  IAB19SharewareFreeware: 'シェアウェア/フリーウェア',
  IAB19TechnologyAndComputing: 'テクノロジーとコンピューティング',
  IAB19ThreeDGraphics: '3Dグラフィックス',
  IAB19Unix: 'Unix',
  IAB19VisualBasic: 'ビジュアルベーシック',
  IAB19WebClipArt: 'ウェブクリップアート',
  IAB19WebDesignHTML: 'ウェブデザイン/HTML',
  IAB19WebSearch: 'ウェブ検索',
  IAB19Windows: 'ウィンドウズ',
  IAB1ArtsAndEntertainment: '芸術とエンターテイメント',
  IAB1BooksAndLiterature: '書籍と文学',
  IAB1CelebrityFanGossip: 'セレブファン/ゴシップ',
  IAB1FineArt: '美術',
  IAB1Humor: 'ユーモア',
  IAB1Movies: '映画',
  IAB1Music: '音楽',
  IAB1Television: 'テレビ',
  IAB20AdventureTravel: '冒険旅行',
  IAB20Africa: 'アフリカ',
  IAB20AirTravel: '航空旅行',
  IAB20AustraliaAndNewZealand: 'オーストラリアとニュージーランド',
  IAB20BedAndBreakfasts: 'ベッド＆ブレックファースト',
  IAB20BudgetTravel: '低予算旅行',
  IAB20BusinessTravel: 'ビジネス旅行',
  IAB20ByUSLocale: '米国ロケール',
  IAB20Camping: 'キャンプ',
  IAB20Canada: 'カナダ',
  IAB20Caribbean: 'カリブ海',
  IAB20Cruises: 'クルーズ',
  IAB20EasternEurope: '東欧',
  IAB20Europe: 'ヨーロッパ',
  IAB20France: 'フランス',
  IAB20Greece: 'ギリシャ',
  IAB20HoneymoonsGetaways: 'ハネムーン/小旅行',
  IAB20Hotels: 'ホテル',
  IAB20Italy: 'イタリア',
  IAB20Japan: '日本',
  IAB20MexicoAndCentralAmerica: 'メキシコと中央アメリカ',
  IAB20NationalParks: '国立公園',
  IAB20SouthAmerica: '南アメリカ',
  IAB20Spas: 'スパ',
  IAB20ThemeParks: 'テーマパーク',
  IAB20Travel: '旅行',
  IAB20TravelingWithKids: '子供連れの旅行',
  IAB20UnitedKingdom: 'イギリス',
  IAB21Apartments: 'アパート',
  IAB21Architects: '建築家',
  IAB21BuyingSellingHomes: '住宅の購入/売却',
  IAB21RealEstate: '不動産',
  IAB22Comparison: '比較',
  IAB22ContestsAndFreebies: 'コンテストと無料プレゼント',
  IAB22Couponing: 'クーポン',
  IAB22Engines: 'エンジン',
  IAB22Shopping: '買い物',
  IAB23AlternativeReligions: '代替宗教',
  IAB23AtheismAgnosticism: '無神論/不可知論',
  IAB23Buddhism: '仏教',
  IAB23Catholicism: 'カトリック',
  IAB23Christianity: 'キリスト教',
  IAB23Hinduism: 'ヒンドゥー教',
  IAB23Islam: 'イスラム教',
  IAB23Judaism: 'ユダヤ教',
  IAB23LatterDaySaints: '末日聖徒',
  IAB23PaganWiccan: '異教徒/ウィッカ教徒',
  IAB23ReligionAndSpirituality: '宗教とスピリチュアリティ',
  IAB24Uncategorized: '未分類',
  IAB25ExtremeGraphicExplicitViolence: '極度に露骨な暴力',
  IAB25HateContent: 'ヘイトコンテンツ',
  IAB25Incentivized: 'インセンティブ',
  IAB25NonStandardContent: '非標準コンテンツ',
  IAB25Pornography: 'ポルノ',
  IAB25ProfaneContent: '俗悪な内容',
  IAB25UnderConstruction: '工事中',
  IAB25UnmoderatedUGC: 'モデレートされていないUGC',
  IAB26CopyrightInfringement: '著作権侵害',
  IAB26IllegalContent: '違法コンテンツ',
  IAB26IllegalContentSub: '違法コンテンツ',
  IAB26SpywareMalware: 'スパイウェア/マルウェア',
  IAB26Warez: 'ワレズ',
  IAB2Automotive: '自動車',
  IAB2AutoParts: '自動車部品',
  IAB2AutoRepair: '自動車修理',
  IAB2BuyingSellingCars: '車の売買',
  IAB2CarCulture: 'カーカルチャー',
  IAB2CertifiedPreOwned: '認定中古車',
  IAB2Convertible: 'コンバーチブル',
  IAB2Coupe: 'クーペ',
  IAB2Crossover: 'クロスオーバー',
  IAB2Diesel: 'ディーゼル',
  IAB2ElectricVehicle: '電気自動車',
  IAB2Hatchback: 'ハッチバック',
  IAB2Hybrid: 'ハイブリッド',
  IAB2Luxury: '贅沢',
  IAB2MiniVan: 'ミニバン',
  IAB2Motorcycles: 'モーロサイクル',
  IAB2OffRoadVehicles: 'オフロード車',
  IAB2PerformanceVehicles: 'パフォーマンス車両',
  IAB2Pickup: '選び出す',
  IAB2RoadSideAssistance: 'ロードサイドアシスタンス',
  IAB2Sedan: 'セダン',
  IAB2TrucksAndAccessories: 'トラックとアクセサリー',
  IAB2VintageCars: 'ヴィンテージカー',
  IAB2Wagon: 'ワゴン',
  IAB3Advertising: '広告',
  IAB3Agriculture: '農業',
  IAB3BiotechBiomedical: 'バイオテクノロジー/バイオメディカル',
  IAB3Business: '仕事',
  IAB3BusinessSoftware: 'ビジネスソフトウェア',
  IAB3Construction: '工事',
  IAB3Forestry: '林業',
  IAB3Government: '政府',
  IAB3GreenSolutions: 'グリーンソリューション',
  IAB3HumanResources: '人事',
  IAB3Logistics: 'ロジスティクス',
  IAB3Marketing: 'マーケティング',
  IAB3Metals: '金属',
  IAB4CareerAdvice: 'キャリアアドバイス',
  IAB4CareerPlanning: 'キャリアプランニング',
  IAB4Careers: 'キャリア',
  IAB4College: 'カレッジ',
  IAB4FinancialAid: '財政援助',
  IAB4JobFairs: '就職フェア',
  IAB4JobSearch: '求人検索',
  IAB4Nursing: '看護',
  IAB4ResumeWritingAdvice: '履歴書の書き方/アドバイス',
  IAB4Scholarships: '奨学金',
  IAB4Telecommuting: '在宅勤務',
  IAB4UsMilitary: '米軍',
  IAB5AdultEducation: '成人教育',
  IAB5ArtHistory: '美術史',
  IAB5CollegeAdministration: '大学管理',
  IAB5CollegeLife: '大学生活',
  IAB5DistanceLearning: '遠隔学習',
  IAB5Education: '教育',
  IAB5EnglishAsSecondLanguage: '第二言語としての英語',
  IAB5GraduateSchool: '大学院',
  IAB5Homeschooling: 'ホームスクーリング',
  IAB5HomeworkStudyTips: '宿題/勉強のヒント',
  IAB5KSixEducators: '幼稚園から小学6年生までの教育者',
  IAB5LanguageLearning: '言語学習',
  IAB5PrivateSchool: '私立学校',
  IAB5SevenToTwelveEducation: '中高の教育',
  IAB5SpecialEducation: '特別支援教育',
  IAB5StudyingBusiness: 'ビジネスを学ぶ',
  IAB6Adoption: '養子縁組',
  IAB6BabiesAndToddlers: '赤ちゃんと幼児',
  IAB6DaycarePreSchool: '保育園・幼稚園',
  IAB6Eldercare: '高齢者介護',
  IAB6FamilyAndParenting: '家族と子育て',
  IAB6FamilyInternet: 'ファミリーインターネット',
  IAB6ParentingKSixKids: '子育て - 幼稚園から小学6年生までの子供たち',
  IAB6ParentingTeens: '10代の子育て',
  IAB6Pregnancy: '妊娠',
  IAB6SpecialNeedsKids: '特別なニーズを持つ子供たち',
  IAB7ADD: '注意欠陥障害',
  IAB7AIDSHIV: 'エイズ/HIV',
  IAB7Allergies: 'アレルギー',
  IAB7AlternativeMedicine: '代替医療',
  IAB7Arthritis: '関節炎',
  IAB7Asthma: '喘息',
  IAB7AutismPDD: '自閉症/広汎性発達障害',
  IAB7BipolarDisorder: '双極性障害',
  IAB7BrainTumor: '脳腫瘍',
  IAB7Cancer: '癌',
  IAB7Cholesterol: 'コレステロール',
  IAB7ChronicFatigueSyndrome: '慢性疲労症候群',
  IAB7ChronicPain: '慢性疼痛',
  IAB7ColdAndFlu: '風邪とインフルエンザ',
  IAB7Deafness: '難聴',
  IAB7DentalCare: '歯科ケア',
  IAB7Depression: 'うつ',
  IAB7Dermatology: '皮膚科',
  IAB7Diabetes: '糖尿病',
  IAB7Epilepsy: 'てんかん',
  IAB7Exercise: '運動',
  IAB7GERDAcidReflux: '胃食道逆流症（GERD）/胃酸逆流',
  IAB7HeadachesMigraines: '頭痛/片頭痛',
  IAB7HealthAndFitness: '健康とフィットネス',
  IAB7HeartDisease: '心臓病',
  IAB7HerbsForHealth: '健康のためのハーブ',
  IAB7HolisticHealing: 'ホリスティックヒーリング',
  IAB7IBSCrohnsDisease: '過敏性腸症候群（IBS）/クローン病',
  IAB7IncestAbuseSupport: '近親相姦/虐待サポート',
  IAB7Incontinence: '失禁',
  IAB7Infertility: '不妊',
  IAB7MensHealth: 'メンズヘルス',
  IAB7Nutrition: '栄養',
  IAB7Orthopedics: '整形外科',
  IAB7PanicAnxietyDisorders: 'パニック障害/不安障害',
  IAB7Pediatrics: '小児科',
  IAB7PhysicalTherapy: '理学療法',
  IAB7PsychologyPsychiatry: '心理学/精神医学',
  IAB7SeniorHealth: 'セニョールヘルス',
  IAB7Sexuality: 'セクシュアリティ',
  IAB7SleepDisorders: '睡眠障害',
  IAB7SmokingCessation: '禁煙',
  IAB7SubstanceAbuse: '薬物乱用',
  IAB7ThyroidDisease: '甲状腺疾患',
  IAB7WeightLoss: '減量',
  IAB7WomensHealth: '女性の健康',
  IAB8AmericanCuisine: 'アメリカ料理',
  IAB8BarbecuesAndGrilling: 'バーベキュー＆グリル',
  IAB8CajunCreole: 'ケイジャン/クレオール',
  IAB8ChineseCuisine: '中華料理',
  IAB8CocktailsBeer: 'カクテル/ビール',
  IAB8CoffeeTea: 'コーヒー/紅茶',
  IAB8CuisineSpecific: '料理別',
  IAB8DessertsAndBaking: 'デザートとベーキング',
  IAB8DiningOut: '外食',
  IAB8FoodAllergies: '食物アレルギー',
  IAB8FoodAndDrink: '食べ物と飲み物',
  IAB8FrenchCuisine: 'フランス料理',
  IAB8HealthLowfatCooking: '健康/低脂肪料理',
  IAB8ItalianCuisine: 'イタリア料理',
  IAB8JapaneseCuisine: '日本料理',
  IAB8MexicanCuisine: 'メキシコ料理',
  IAB8Vegan: 'ビーガン',
  IAB8Vegetarian: 'ベジタリアン',
  IAB8Wine: 'ワイン',
  IAB9ArtsAndCrafts: '芸術と工芸',
  IAB9ArtTechnology: 'アート/テクノロジー',
  IAB9Beadwork: 'ビーズ細工',
  IAB9Birdwatching: 'バードウォッチング',
  IAB9BoardGamesPuzzles: 'ボードゲーム/パズル',
  IAB9CandleAndSoapMaking: 'キャンドルと石鹸作り',
  IAB9CardGames: 'カードゲーム',
  IAB9Chess: 'チェス',
  IAB9Cigars: '葉巻',
  IAB9Collecting: '収集',
  IAB9ComicBooks: 'コミック',
  IAB9DrawingSketching: '描画/スケッチ',
  IAB9FreelanceWriting: 'フリーランスライティング',
  IAB9Genealogy: '系譜学',
  IAB9GettingPublished: '出版',
  IAB9Guitar: 'ギター',
  IAB9HobbiesAndInterests: '趣味と興味',
  IAB9HomeRecording: 'ホームレコーディング',
  IAB9InvestorsAndPatents: '投資家と特許',
  IAB9JewelryMaking: 'ジュエリー作り',
  IAB9MagicAndIllusion: 'マジック＆イリュージョン',
  IAB9Needlework: '針仕事',
  IAB9Painting: '絵画',
  IAB9Photography: '写真',
  IAB9Radio: '無線',
  IAB9RoleplayingGames: 'ロールプレイングゲーム',
  IAB9SciFiAndFantasy: 'SFとファンタジー',
  IAB9Scrapbooking: 'スクラップブッキング',
  IAB9Screenwriting: '脚本',
  IAB9StampsAndCoins: '切手とコイン',
  IAB9VideoAndComputerGames: 'ビデオゲームとコンピュータゲーム',
  IAB9Woodworking: '木工',
  IABEmpty: '空',
  ReviewBlockedCreatives: 'ブロックされたクリエイティブを確認する',
  Rule: 'ルール',
  RuleExceptionName: 'ルール例外名',
  RuleTargeting: 'ルールターゲティング',
  RuleTargetingDescription: 'ルールに適用するオブジェクトを選択し、目的の粒度に達するようにターゲティングパラメータを設定します。',
  RuleType: 'ルールタイプ',
  RuleTypeDescription: '除外または含めるルールの種類と要素を定義します',
};